import React from 'react';
import '../styles/AboutHero.css';

const AboutHero = () => {
  return (
    <div className="about-hero-container">
      {/* This is the background image specific to the About page */}
    </div>
  );
};

export default AboutHero;